import { createContext, useCallback, useContext, useState } from 'react';
import { clearAuthCookie, getCookie } from './utils/cookies';

const AuthContext = createContext(null);

const API_AUTH_URL = process.env.REACT_APP_AUTH_API_URL;

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const checkAuth = useCallback(async () => {
        const token = getCookie('MMAUTH');

        if (!token) {
            setIsAuthenticated(false);
            return false;
        }

        try {
            // Chiamata API al backend per validare il JWT
            const response = await fetch(`${API_AUTH_URL}/auth/check`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'MmTkn': token,
                }
            });

            if (response.status === 200 && response.ok) {
                setIsAuthenticated(true);
                return true;
            } else {
                setIsAuthenticated(false);
                // Rimuovi il cookie non valido
                clearAuthCookie();
                return false;
            }
        } catch (error) {
            setIsAuthenticated(false);
            return false;
        }
    }, []);

    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        clearAuthCookie();
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                checkAuth,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth deve essere usato all\'interno di AuthProvider');
    }
    return context;
};
